import { IStageMapGroup } from '@forwardflow/types/onboarding'
import { apiGet, apiPost } from './Axios/configs'
import { ResponseSuccess } from '@forwardflow/types'

export class StageMappingService {
   /**
    * Fetches stage mappings from the Forward Flow development API.
    *
    *
    * @returns {Promise<IStageMapGroup[]>} A promise that resolves to an array of stage mapping groups.
    * @throws {Error} If the HTTP request fails.
    */
   static async getStageMapping(): Promise<IStageMapGroup[]> {
      const response = await apiGet<ResponseSuccess<IStageMapGroup[]>>({
         apiPath: '/stage-mappings',
      })
      return response?.data || []
   }

   /**
    * Fetches stage mappings for a specific organization from the Forward Flow development API.
    *
    * @param {string} orgId - The organization ID to use for the request (sent as the X-ORG header).
    * @returns {Promise<IStageMapGroup[]>} A promise that resolves to an array of stage mapping groups for the org.
    * @throws {Error} If the HTTP request fails.
    */
   static async updateStageMapping({
      stageMapping,
   }: {
      stageMapping: IStageMapGroup[]
   }) {
      const response = await apiPost<ResponseSuccess<object>>({
         apiPath: '/stage-mappings',
         data: stageMapping,
      })
      return response || undefined
   }
}
